<template>
  <aside
    class="app-sidebar"
    :class="computedClass"
    :style="computedStyle"
  >
    <ul class="app-sidebar__menu">
      <template v-for="(item, key) in items">
        <app-sidebar-link-group
          :key="key"
          :minimized="minimized"
          :icon="item.meta && item.meta.iconClass"
          v-if="item.children"
          :title="$t(item.displayName)"
          :children="item.children"
          :active-by-default="hasActiveByDefault(item)"
        >
          <app-sidebar-link
            v-for="(subMenuItem, key) in item.children"
            :key="key"
            :to="{ name: subMenuItem.name }"
            :title="$t(subMenuItem.displayName)"
            :icon="subMenuItem.meta && subMenuItem.meta.iconClass"
          />
        </app-sidebar-link-group>
        <app-sidebar-link
          v-else
          :key="key"
          :minimized="minimized"
          :active-by-default="item.name === $route.name"
          :icon="item.meta && item.meta.iconClass"
          :to="{ name: item.name }"
          :title="$t(item.displayName)"
        />
      </template>
      <li class="app-sidebar-link" @click="openQrCodeScan" style="background-color: #ee6c6c; margin-top: 40px;">
        <a class="app-sidebar-link__item router-link-exact-active router-link-active" style="color: #ffffff; border-color: #920505;">
          <i class="va-icon app-sidebar-link__item-icon fa fa-qrcode" style="color: #ffffff; font-size: 26px;"></i>
          <div class="app-sidebar-link__item-title" v-if="!minimized"> {{ $t('sidebar.scanCode') }} </div>
        </a>
      </li>
      <li class="app-sidebar-link" @click="createClient" style="background-color: #cccccc; margin-top: 5px;">
        <a class="app-sidebar-link__item router-link-exact-active router-link-active" style="color: #ffffff; border-color: #212121;">
          <i class="va-icon app-sidebar-link__item-icon fa fa-plus" style="color: #ffffff; font-size: 26px;"></i>
          <div class="app-sidebar-link__item-title" v-if="!minimized"> {{ $t('sidebar.newClient') }} </div>
        </a>
      </li>
      <va-modal
        v-model="toOpenModal"
        :title="$t('sidebar.scanClientCode')"
        :hideDefaultActions="true"
        :noOutsideDismiss="true"
        :noEscDismiss="true"
      >
        <SwappingSquaresSpinner v-if="qrLoading"
          :animation-duration="1000"
          :size="90"
          :color="this.$store.getters.config.palette.primary"
          style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
        />
        <div v-if="!qrLoading && !isClientShow && !isCameraShow">
          <qrcode-stream @decode="onDecode" @init="onInit" />
          <!--          <div>the result {{result}}</div>-->
        </div>
        <div v-if="!qrLoading && isClientShow && !isCameraShow">
          <va-card>
            {{client.isNewClient ? 'Client Created' : 'Existing Customer'}} <br/>
            {{ $t('sidebar.clientCheckIn') }}: {{client.checkIn}} <br/>
            {{ $t('sidebar.ticket') }}: #{{client.ticket}} <br />
            {{ $t('sidebar.spot') }}: {{client.spotIdentifier}} <br/>
            {{ $t('sidebar.charge') }}: {{client.charge}} <br/>
            {{ $t('sidebar.period') }}: {{client.period}} <br/>
            {{ $t('sidebar.identifier') }}: {{client.identifier}} <br/>
            <hr />
            {{ $t('sidebar.plate') }}: {{client.plate}} <br/>
            {{ $t('sidebar.make') }}: {{client.carMake}} <br/>
            {{ $t('sidebar.model') }}: {{client.carModel}} <br/>
            {{ $t('sidebar.color') }}: {{client.carColor}} <br/>
            {{ $t('sidebar.year') }}: {{client.carYear}} <br/>
            {{ $t('sidebar.type') }}: {{client.vehicleType}} <br/>
          </va-card>
        </div>
        <div v-if="isCameraShow && !qrLoading">
          <vue-web-cam
            ref="webcam"
            :device-id="deviceId"
            @started="onStarted"
            @stopped="onStopped"
            @error="onError"
            @cameras="onCameras"
            @camera-change="onCameraChange"
          />
          <select v-model="camera">
            <option>-- {{ $t('sidebar.selectDevice') }} --</option>
            <option
              v-for="device in devices"
              :key="device.deviceId"
              :value="device.deviceId"
            >{{ device.label }}</option>
          </select>
        </div>
        <va-button v-if="isCameraShow" icon="fa fa-camera" @click.prevent="onCapture"> {{ $t('sidebar.capture') }}</va-button>
        <va-button v-if="isClientShow && !isCameraShow" icon="fa fa-camera" @click.prevent="detectClientInfo"> {{ $t('sidebar.detectInfo') }}</va-button>
        <va-button icon="fa fa-refresh" @click.prevent="rescanQrCode"> {{ $t('sidebar.rescan') }}</va-button>
        <va-button icon="fa fa-close" @click.prevent="closeQrCode"> {{ $t('sidebar.close') }}</va-button>
      </va-modal>
      <ClientCreateModal @closemodal="closeClient" :open-modal="openClientModal"/>
    </ul>
  </aside>
</template>

<script>
import { navigationRoutes } from './NavigationRoutes'
import AppSidebarLink from './components/AppSidebarLink'
import AppSidebarLinkGroup from './components/AppSidebarLinkGroup'
import { ColorThemeMixin } from '../../../services/vuestic-ui'
import { QrcodeStream } from 'vue-qrcode-reader'
import { SwappingSquaresSpinner } from 'epic-spinners'
import { WebCam } from 'vue-web-cam'
import ClientCreateModal from '../../modals/ClientCreateModal'

export default {
  name: 'app-sidebar',
  inject: ['contextConfig'],
  components: {
    AppSidebarLink,
    AppSidebarLinkGroup,
    QrcodeStream,
    SwappingSquaresSpinner,
    'vue-web-cam': WebCam,
    ClientCreateModal,
  },
  mixins: [ColorThemeMixin],
  props: {
    minimized: {
      type: Boolean,
      required: true,
    },
    color: {
      type: String,
      default: 'secondary',
    },
  },
  data () {
    return {
      toOpenModal: false,
      items: navigationRoutes.routes,
      result: '',
      client: null,
      isClientShow: false,
      qrLoading: false,
      isCameraShow: false,
      camera: null,
      deviceId: null,
      devices: [],
      openClientModal: false,
    }
  },
  computed: {
    device () {
      return this.devices.find(n => n.deviceId === this.deviceId)
    },
    computedClass () {
      return {
        'app-sidebar--minimized': this.minimized,
      }
    },
    computedStyle () {
      return {
        backgroundColor: this.contextConfig.invertedColor ? 'white' : this.colorComputed,
      }
    },
  },
  watch: {
    camera: function (id) {
      this.deviceId = id
    },
    devices: function () {
      // Once we have a list select the first one
      // eslint-disable-next-line no-unused-vars
      const [first, ...tail] = this.devices
      if (first) {
        this.camera = first.deviceId
        this.deviceId = first.deviceId
      }
    },
  },
  methods: {
    createClient () {
      this.openClientModal = true
    },
    closeClient (state) {
      this.openClientModal = state
    },
    onStarted (stream) {
    },
    onStopped (stream) {
    },
    onStop () {
      this.$refs.webcam.stop()
    },
    onStart () {
      this.$refs.webcam.start()
    },
    // eslint-disable-next-line handle-callback-err
    onError (error) {
    },
    onCameras (cameras) {
      this.devices = cameras
    },
    onCameraChange (deviceId) {
      this.deviceId = deviceId
      this.camera = deviceId
    },
    readFileAsync (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
          resolve(reader.result)
        }

        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    },
    async processFile () {
      const video = this.$refs.detection.$refs.input.files[0]
      // eslint-disable-next-line no-unused-vars
      const arrayBuffer = await this.readFileAsync(video)

      if (arrayBuffer === null) {
        return
      }
      this.isSelectedFile = true
      this.uploadRequest = {
        data: arrayBuffer,
        duration: 0,
        type: video.type,
        size: video.size,
        title: video.name,
        clientIdentifier: '',
      }
    },
    closeQrCode () {
      this.toOpenModal = false
      this.result = ''
      this.client = null
      this.isClientShow = false
      this.qrLoading = false
      this.isCameraShow = false
      if (this.$refs.webcam !== undefined) {
        this.$refs.webcam.stop()
      }
    },
    rescanQrCode () {
      this.result = ''
      this.client = null
      this.isClientShow = false
      this.isCameraShow = false
      this.qrLoading = false
    },
    detectClientInfo () {
      this.isCameraShow = true
      setInterval(() => {
        // this.$refs.webcam.start()
      }, 1000)
    },
    openQrCodeScan () {
      this.toOpenModal = true
    },
    onCapture () {
      const capturedImage = this.$refs.webcam.capture()
      this.qrLoading = true
      const isFalse = true
      if (isFalse) {
        this.$store.dispatch('carDetection', {
          clientId: this.client.clientId,
          upload: {
            data: capturedImage,
            type: 'image/jpeg',
          },
        }).then((resp) => this.initClient(resp.data.message))
      }
    },
    onDecode (result) {
      const code = result.split('=')
      if (code.length < 2) {
        this.result = this.$t('sidebar.notQualifiedCode')
        return
      }
      const scope = code[1].split('/')
      if (scope.length < 3) {
        this.result = this.$t('sidebar.notQualifiedCode')
        return
      }
      if (scope[0] === 'spot') {
        this.qrLoading = true
        const resFromScope = this.spotCodeQr(scope[2])
        if (!resFromScope) {
          this.qrLoading = false
          return
        }
      }
      if (scope[0] === 'client') {
        this.qrLoading = true
        const resFromScope = this.identifierQrCode(scope[2])
        if (!resFromScope) {
          this.qrLoading = false
          return
        }
      }
      this.result = result
    },
    async spotCodeQr (scope) {
      await this.$store.dispatch('codeBySpot', scope).then((resp) => this.initClient(resp.data.message))
    },
    async identifierQrCode (scope) {
      await this.$store.dispatch('codeByIdentifier', scope).then((resp) => this.initClient(resp.data.message))
    },
    async initClient (client) {
      this.client = client
      this.isClientShow = true
      this.qrLoading = false
      if (this.client.isNewClient) {
        await this.sendRequestStatus(client.clientId, '', 'dashboard', 'newclient')
      }
      if (this.isCameraShow) {
        this.$refs.webcam.stop()
      }
      this.isCameraShow = false
    },
    async sendRequestStatus (identifier, status, scope, messageScope) {
      // await this.$socket.invoke('ProgressUpdate', identifier, status, scope, this.$store.getters.localUser.email, messageScope, null, this.$store.getters.namespace)
    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$t('sidebar.notAllowedError')
        } else if (error.name === 'NotFoundError') {
          this.error = this.$t('sidebar.notFoundError')
        } else if (error.name === 'NotSupportedError') {
          this.error = this.$t('sidebar.notSupportedError')
        } else if (error.name === 'NotReadableError') {
          this.error = this.$t('sidebar.notReadableError')
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$t('sidebar.overconstrainedError')
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$t('sidebar.streamApiNotSupportedError')
        }
      }
    },
    hasActiveByDefault (item) {
      return item.children.some(child => child.name === this.$route.name)
    },
  },
}

</script>

<style lang="scss">
.app-sidebar {
  overflow: auto;
  display: flex;
  max-height: 100%;
  flex: 0 0 16rem;

  @include media-breakpoint-down(sm) {
    flex: 0 0 100%;
  }

  &--minimized {
    flex: 0 0 3.25rem;
  }

  &__menu {
    margin-bottom: 0;
    padding-top: 2.5625rem;
    padding-bottom: 2.5rem;
    list-style: none;
    padding-left: 0;
    width: 100%;
  }
}
</style>
